<div class="d-flex gap-4 p-5 h-100" #statsTable [attr.data-widget-id]="widgetConfig?.title?.toLowerCase().split(' ').join('-')">
	<!-- Static text column (first column) -->
	<div class="d-flex flex-column stats-column">
		<div class="header-row">{{ widgetData?.dimensions[0]?.name }}</div>
		<div *ngFor="let row of widgetData?.data" class="d-flex flex-grow-1 align-items-center">
			<div 
				class="label flex-grow-1" 
				[class.header-content]="isHeaderContent(row[0])"
				[innerHTML]="formatString(row[0])"></div>
		</div>
	</div>

	<!-- Dynamic value columns -->
	<ng-container *ngFor="let col of widgetData?.dimensions; index as i">
		<ng-container *ngIf="i > 0">
			<!-- Check if this column has any values with spaces to determine if we need to split -->
			<ng-container *ngIf="columnHasSpacedValues(i); else singleColumn">
				<!-- First part column (numbers) -->
				<div class="d-flex flex-column stats-column flex-grow-1">
					<div class="header-row">{{ col.name }}</div>
					<div
						*ngFor="let row of widgetData?.data"
						class="d-flex flex-grow-1 align-items-center justify-content-end value-container"
						[class.has-header-content]="isHeaderContent(row[i])">
						<div
							#autoSize
							class="value value-main"
							[class.header-content]="isHeaderContent(row[i])"
							[style.color]="isHeaderContent(row[i]) ? null : defaultColourSet[i - 1]">
							{{ getFirstPart(row[i]) }}
						</div>
					</div>
				</div>
				<!-- Second part column (percentages) -->
				<div class="d-flex flex-column stats-column">
					<div class="header-row"></div>
					<div
						*ngFor="let row of widgetData?.data"
						class="d-flex flex-grow-1 align-items-center justify-content-end value-container"
						[class.has-header-content]="isHeaderContent(row[i])">
						<div
							#autoSize
							class="value value-main"
							[class.header-content]="isHeaderContent(row[i])"
							[style.color]="isHeaderContent(row[i]) ? null : defaultColourSet[i - 1]">
							{{ getSecondPart(row[i]) }}
						</div>
					</div>
				</div>
			</ng-container>
			
			<!-- Single column for values without spaces -->
			<ng-template #singleColumn>
				<div class="d-flex flex-column stats-column flex-grow-1">
					<div class="header-row">{{ col.name }}</div>
					<div
						*ngFor="let row of widgetData?.data"
						class="d-flex flex-grow-1 align-items-center justify-content-end value-container"
						[class.has-header-content]="isHeaderContent(row[i])">
						<div
							#autoSize
							class="value value-main"
							[class.header-content]="isHeaderContent(row[i])"
							[style.color]="isHeaderContent(row[i]) ? null : defaultColourSet[i - 1]"
							[innerHTML]="formatString(row[i])">
						</div>
					</div>
				</div>
			</ng-template>
		</ng-container>
	</ng-container>
</div>
